import React from 'react';
import { View } from 'react-native';
export default function Spacing(props) {
    const { size = 'default', style, type = 'vertical', ...otherProps } = props;
    const sty = {};
    const keyName = type === 'vertical' ? 'height' : 'width';
    sty[keyName] = 10;
    if (size === 'small') {
        sty[keyName] = 5;
    }
    else if (size === 'large') {
        sty[keyName] = 15;
    }
    else if (typeof size === 'number') {
        sty[keyName] = size;
    }
    return <View style={[sty, style]} {...otherProps}/>;
}
